(function () {
  var root = document.querySelector('[data-d2x]');
  if (!root) return;

  // state: q1 null|'d21x'|'other'|'unsure'  q2 null|'keep'|'new'  q3 null|'no'|'yes'
  var state = { q1: null, q2: null, q3: null };
  var receipts = { q1: null, q2: null, q3: null };
  var booted = false;
  var UNANSWERED = root.querySelector('[data-rail-answer="q1"]').textContent;
  var VIEWS = ['q1', 'q2', 'q3', 'out-e', 'out-ea', 'out-station', 'out-check'];

  var view = function (n) { return root.querySelector('[data-view="' + n + '"]'); };
  var rail = function (n) { return root.querySelector('[data-rail="' + n + '"]'); };
  var ans = function (n) { return root.querySelector('[data-rail-answer="' + n + '"]'); };
  var outTitle = root.querySelector('[data-rail-out-title]');
  var defaultTitle = outTitle.textContent;

  // This theme (Horizon) scrolls .page-wrapper, not the window, and that
  // container carries scroll-behavior:smooth which swallows scrollIntoView.
  // Assigning scrollTop is the only thing that reliably moves it.
  function scrollToEl(el, offset) {
    var sc = el.parentElement;
    while (sc && sc !== document.body) {
      var ov = getComputedStyle(sc).overflowY;
      if ((ov === 'auto' || ov === 'scroll') && sc.scrollHeight > sc.clientHeight) break;
      sc = sc.parentElement;
    }
    var y = el.getBoundingClientRect().top - (offset || 90);
    if (sc && sc !== document.body) {
      var prev = sc.style.scrollBehavior;
      sc.style.scrollBehavior = 'auto';
      sc.scrollTop = sc.scrollTop + y - sc.getBoundingClientRect().top;
      sc.style.scrollBehavior = prev;
    } else {
      window.scrollTo(0, window.pageYOffset + y);
    }
  }

  function route() {
    if (!state.q1) return 'q1';
    if (state.q1 === 'other') return 'out-station';
    if (state.q1 === 'unsure') return 'out-check';
    if (!state.q2) return 'q2';
    if (state.q2 === 'new') return 'out-station';
    if (!state.q3) return 'q3';
    return state.q3 === 'yes' ? 'out-ea' : 'out-e';
  }

  function setRail(el, active, done) {
    el.className = 'd2x__step' + (active ? ' is-active' : '') + (done ? ' is-done' : '');
  }

  function render() {
    var shown = route();
    VIEWS.forEach(function (n) { view(n).hidden = n !== shown; });

    var q2on = state.q1 === 'd21x', q3on = q2on && state.q2 === 'keep';
    setRail(rail('q1'), !state.q1, !!state.q1);
    ans('q1').textContent = state.q1 ? receipts.q1 : UNANSWERED;
    rail('q2').hidden = !q2on;
    setRail(rail('q2'), q2on && !state.q2, q2on && !!state.q2);
    ans('q2').textContent = state.q2 ? receipts.q2 : UNANSWERED;
    rail('q3').hidden = !q3on;
    setRail(rail('q3'), q3on && !state.q3, q3on && !!state.q3);
    ans('q3').textContent = state.q3 ? receipts.q3 : UNANSWERED;

    var out = shown.indexOf('out-') === 0;
    rail('out').className = 'd2x__step ' + (out ? 'is-active' : 'is-pending');
    outTitle.textContent = out ? view(shown).getAttribute('data-rail-title') : defaultTitle;

    root.querySelector('[data-startover]').hidden = !state.q1;
    root.setAttribute('data-state', state.q1 ? 'answered' : 'start');

    if (booted && window.innerWidth < 900) scrollToEl(root.querySelector('.d2x__pane'), 80);
  }

  root.querySelectorAll('[data-answer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var p = btn.getAttribute('data-answer').split(':'), r = btn.getAttribute('data-receipt');
      if (p[0] === 'q1') { state.q1 = p[1]; state.q2 = null; state.q3 = null; receipts.q1 = r; }
      else if (p[0] === 'q2') { state.q2 = p[1]; state.q3 = null; receipts.q2 = r; }
      else { state.q3 = p[1]; receipts.q3 = r; }
      render();
    });
  });
  rail('q1').addEventListener('click', function () { state.q1 = null; state.q2 = null; state.q3 = null; render(); });
  rail('q2').addEventListener('click', function () { state.q2 = null; state.q3 = null; render(); });
  rail('q3').addEventListener('click', function () { state.q3 = null; render(); });
  root.querySelector('[data-startover]').addEventListener('click', function () {
    state.q1 = null; state.q2 = null; state.q3 = null; render();
  });

  // Quantity steppers, and keep the checkout permalink in step with them.
  root.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var inp = b.parentElement.querySelector('input');
      var v = parseInt(inp.value || '1', 10) + parseInt(b.getAttribute('data-qty'), 10);
      inp.value = Math.min(20, Math.max(1, v));
      inp.dispatchEvent(new Event('input'));
    });
  });
  root.querySelectorAll('form[data-buy]').forEach(function (f) {
    var inp = f.querySelector('input[name=quantity]'), link = f.querySelector('[data-checkout]');
    var id = f.querySelector('input[name=id]').value;
    if (!inp || !link) return;
    inp.addEventListener('input', function () {
      link.href = '/cart/' + id + ':' + (parseInt(inp.value, 10) || 1);
    });
  });

  render();
  booted = true;

  // Replay restarts every animation in the scene by cloning it.
  var replay = document.querySelector('[data-replay]'), scene = document.querySelector('[data-scene]');
  if (replay && scene) {
    replay.addEventListener('click', function () {
      var c = scene.cloneNode(true);
      scene.parentNode.replaceChild(c, scene);
      scene = c;
    });
  }

  // Hero "Find my part" — in-page jump that works inside Horizon's scroller.
  var jump = document.querySelector('[data-jump]');
  if (jump) {
    jump.addEventListener('click', function (e) {
      e.preventDefault();
      scrollToEl(document.getElementById('db-find'), 70);
    });
  }

  // Hero "Free fit check" and the #db-check deep link open the finder on the
  // free-check outcome (same as answering "Not sure" to question 1).
  function openCheck() {
    var unsure = root.querySelector('[data-answer="q1:unsure"]');
    state.q1 = 'unsure'; state.q2 = null; state.q3 = null;
    receipts.q1 = unsure.getAttribute('data-receipt');
    render();
    scrollToEl(document.getElementById('db-find'), 70);
  }
  var jumpCheck = document.querySelector('[data-jump-check]');
  if (jumpCheck) {
    jumpCheck.addEventListener('click', function (e) { e.preventDefault(); openCheck(); });
  }

  // Hash handling: on load (deferred to load because layout is still settling)
  // and on hashchange, since a hash-only navigation does not re-run this script.
  function onHash() {
    if (location.hash === '#db-check') openCheck();
    else if (location.hash === '#db-find') scrollToEl(document.getElementById('db-find'), 70);
  }
  if (location.hash === '#db-check' || location.hash === '#db-find') {
    window.addEventListener('load', function () { setTimeout(onHash, 0); });
  }
  window.addEventListener('hashchange', onHash);
})();
